var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid",attrs:{"id":"Home"}},[_c('center',[_c('h1',{staticClass:"text-center text-white"},[_vm._v(_vm._s(_vm.filterTitle()))])]),_c('br'),_c('QuestionsList',{attrs:{"questionList":_vm.$store.getters.getQasFiltered,"filter":_vm.$route.params.filter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }